<div id="feature-filters">
  <div class="row">
    <p class="title">Características</p>
    <a class="clean-filters">Limpar</a>
  </div>

  <div class="row">
    <app-input id="tipo-imovel" class="one-third" label="Tipo de imóvel / subtipo" placeholder="Apartamento">
    </app-input>
  </div>

  <div class="row">
    <div class="one-half">
      <label>Finalidade</label>
      <lib-input-checkbox id="" class="item-action" label="Venda"></lib-input-checkbox>
      <lib-input-checkbox id="" class="item-action" label="Locação"></lib-input-checkbox>
    </div>

    <div class="one-half">
      <label>Utilização</label>
      <lib-input-checkbox id="" class="item-action" label="Residencial"></lib-input-checkbox>
      <lib-input-checkbox id="" class="item-action" label="Comercial"></lib-input-checkbox>
    </div>
  </div>

  <div class="row">

    <div class="one-half">
      <label>
        <img src="/assets/svgs/cama.svg" alt="cama">
        <span>Quantidade de dormitórios</span>
      </label>

      <div class="selector">
        <input type="checkbox" id="bedroom-1">
        <label for="bedroom-1">01</label>

        <input type="checkbox" id="bedroom-2">
        <label for="bedroom-2">02</label>

        <input type="checkbox" id="bedroom-3">
        <label for="bedroom-3">03</label>

        <input type="checkbox" id="bedroom-4">
        <label for="bedroom-4">04+</label>
      </div>
    </div>

    <div class="one-half">
      <label>
        <img src="/assets/svgs/cama.svg" alt="cama">
        <span>Quantidade de suítes</span>
      </label>

      <div class="selector">
        <input type="checkbox" id="suites-1">
        <label for="suites-1">01</label>

        <input type="checkbox" id="suites-2">
        <label for="suites-2">02</label>

        <input type="checkbox" id="suites-3">
        <label for="suites-3">03</label>

        <input type="checkbox" id="suites-4">
        <label for="suites-4">04+</label>
      </div>
    </div>

  </div>

  <div class="row">

    <div class="one-half">
      <label>
        <img src="/assets/svgs/shower.svg" alt="chuveiro">
        <span>Quantidade de banheiros</span>
      </label>
      <div class="selector">

        <input type="checkbox" id="bathroom-1">
        <label for="bathroom-1">01</label>

        <input type="checkbox" id="bathroom-2">
        <label for="bathroom-2">02</label>

        <input type="checkbox" id="bathroom-3">
        <label for="bathroom-3">03</label>

        <input type="checkbox" id="bathroom-4">
        <label for="bathroom-4">04+</label>
      </div>
    </div>

    <div class="one-half">
      <label>
        <img src="/assets/svgs/car.svg" alt="chuveiro">
        <span>Quantidade de vagas na garagem</span>
      </label>
      <div class="selector">

        <input type="checkbox" id="car-space-1">
        <label for="car-space-1">01</label>

        <input type="checkbox" id="car-space-2">
        <label for="car-space-2">02</label>

        <input type="checkbox" id="car-space-3">
        <label for="car-space-3">03</label>

        <input type="checkbox" id="car-space-4">
        <label for="car-space-4">04+</label>
      </div>
    </div>

  </div>

  <div class="row">
    <div class="one-half">
      <app-range-selector label="Área útil" icon="metric" min="0" max="100"></app-range-selector>
    </div>
    <div class="one-half">
      <app-range-selector label="Área total" icon="metric" min="0" max="100"></app-range-selector>
    </div>
  </div>

  <div class="row">
    <div class="full">
      <label>Detalhes</label>
      <div class="one-third">
        <lib-input-checkbox id="" class="item-action" label="Portaria"></lib-input-checkbox>
        <lib-input-checkbox id="" class="item-action" label="Cozinha mobiliada"></lib-input-checkbox>
        <lib-input-checkbox id="" class="item-action" label="Lavabo"></lib-input-checkbox>
        <lib-input-checkbox id="" class="item-action" label="Quintal"></lib-input-checkbox>
      </div>
      <div class="one-third">
        <lib-input-checkbox id="" class="item-action" label="Churrasqueira"></lib-input-checkbox>
        <lib-input-checkbox id="" class="item-action" label="Dependências de empregado"></lib-input-checkbox>
        <lib-input-checkbox id="" class="item-action" label="Cozinha americana"></lib-input-checkbox>
        <lib-input-checkbox id="" class="item-action" label="Ar condicionado"></lib-input-checkbox>
      </div>
    </div>

  </div>

  <app-select class="row" labelText="Mais detalhes do imóvel" height="110" field="name" sizeList="3"
    [disabled]="!dropdownOptions.length" [listItems]="dropdownOptions">
  </app-select>

  <div class="row">
    <div class="selector rectangular full">
      <input type="checkbox" id="s-1">
      <label for="s-1">Com fotos</label>

      <input type="checkbox" id="s-2">
      <label for="s-2">Com placa</label>

      <input type="checkbox" id="s-3">
      <label for="s-3">Adm locação</label>

      <input type="checkbox" id="s-4">
      <label for="s-4">Aut venda/loc </label>

      <input type="checkbox" id="s-5">
      <label for="s-5">Aut venda/loc</label>

      <input type="checkbox" id="s-6">
      <label for="s-6">Exclusividade</label>

      <input type="checkbox" id="s-7">
      <label for="s-7">Alto padrão</label>

      <input type="checkbox" id="s-8">
      <label for="s-8">Aceita permuta</label>

      <input type="checkbox" id="s-9">
      <label for="s-9">Aceita parcelamento</label>

      <input type="checkbox" id="s-10">
      <label for="s-10">Aceita valor diferenciado</label>

      <input type="checkbox" id="s-11">
      <label for="s-11">Fiança gratuita</label>
    </div>
  </div>
</div>